// removed by extract-text-webpack-plugin
module.exports = {"container":"src-components-item-link----styles-module---container---3l1sL","item":"src-components-item-link----styles-module---item---3rm4p","title":"src-components-item-link----styles-module---title---IyplK","imageContainer":"src-components-item-link----styles-module---imageContainer---3X2PB"};


//////////////////
// WEBPACK FOOTER
// ./src/components/item-link/styles.module.css
// module id = 629
// module chunks = 168707334958949